<template>
  <div class="settings-action-row">
    <div class="_text">
      <div class="_title">
        <slot name="title" />
      </div>
      <p class="_description">
        <slot name="description" />
      </p>
    </div>
    <slot />
  </div>
</template>

<script setup>
</script>

<style scoped lang="scss" type="text/scss">
  .settings-action-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1.6rem;

    ._title {
      margin-bottom: .4rem;
      font-size: $font-size-4;
      font-weight: $font-weight-medium;
      color: $font-color-primary;
    }

    ._description {
      margin-bottom: 0;
      color: $font-color-secondary;
    }
  }
</style>
